import { render, staticRenderFns } from "./DropdownDownload.vue?vue&type=template&id=aff4f4fe&scoped=true"
import script from "./DropdownDownload.vue?vue&type=script&lang=js"
export * from "./DropdownDownload.vue?vue&type=script&lang=js"
import style0 from "./DropdownDownload.vue?vue&type=style&index=0&id=aff4f4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff4f4fe",
  null
  
)

export default component.exports